import * as React from "react";
import FeaturedNavLink from "../elements/featured-nav-link";

import SectionTitle from "../elements/section-title";
import { useStaticQuery, graphql } from "gatsby";
import Img from "gatsby-image";
const FrameSection = () => {
    const data = useStaticQuery(graphql`
        query FrameSectionImage {
            file(relativePath: { eq: "design-page/frame-image.jpg" }) {
                id
                childImageSharp {
                    fluid(
                        srcSetBreakpoints: [800, 1200]
                        sizes: "(min-width: 768px) 1200px, 800px"
                    ) {
                        ...GatsbyImageSharpFluid_withWebp_noBase64
                    }
                }
            }
        }
    `);
    return (
        <div className="guttered-container">
            {/* Nav links row */}
            <div className="container-fluid position-relative">
                <div className="row">
                    <div className="col-3">
                        <FeaturedNavLink
                            hash="frame"
                            title="Frame"
                            color="#e5b2a1"
                            valign="top"
                        >
                            FRAME
                        </FeaturedNavLink>
                    </div>
                    <div className="col-3">
                        <FeaturedNavLink
                            hash="handlebar"
                            title="Handlebar"
                            color="#92c7bc"
                            valign="top"
                        >
                            HANDLEBAR
                        </FeaturedNavLink>
                    </div>
                    <div className="col-3">
                        <FeaturedNavLink
                            hash="tyre"
                            title="Tyre"
                            color="#d1c5b4"
                            valign="top"
                        >
                            TYRE
                        </FeaturedNavLink>
                    </div>
                    <div className="col-3">
                        <FeaturedNavLink
                            hash="gear-set"
                            title="Gear Set"
                            color="#414f2c"
                            valign="top"
                        >
                            GEAR SET
                        </FeaturedNavLink>
                        <FeaturedNavLink
                            hash="center-stand"
                            title="Center Stand"
                            halign="right"
                            color="#48637e"
                            valign="top"
                        >
                            CENTER STAND
                        </FeaturedNavLink>
                    </div>
                </div>
            </div>

            <div className="container-fluid">
                {/* Spacer row */}
                <div className="row">
                    <div className="col-6 col-md-3 tb-border-start">
                        <div className="py-4"></div>
                        <div className="py-2 d-md-none"></div>
                        <div className="py-1 pb-0 d-md-none"></div>
                        <div className="py-5 d-none d-md-block"></div>
                        <div className="py-1 d-none d-md-block"></div>
                    </div>
                    <div className="col-6 col-md-3 tb-border-start tb-border-end tb-border-end-md-0"></div>
                    <div className="col-6 col-md-3 d-none d-md-block tb-border-start"></div>
                    <div className="col-6 col-md-3 d-none d-md-block tb-border-start tb-border-end"></div>
                </div>

                {/* Row 2 */}
                <div className="row">
                    <div className="col-6 col-md-3 tb-border-start">
                        <div className="flex-content-box">
                            <SectionTitle color="#e5b2a1">FRAME</SectionTitle>

                            <div className="description-container js-reveal">
                                <div className="py-4 pb-0 d-md-none"></div>
                                <div className="py-3 d-none d-md-block"></div>
                                <div className="py-3 d-none d-md-block"></div>
                                <p className="tb-font-notosans-light">
                                    服装を問わず乗り降りしやすいスタッガードフレーム*。
                                    細身のシルエットと艶のあるフレームカラーが街に映える美しさです。
                                    <br />
                                    <br />
                                    *スタッガードフレームとは、サドルとハンドルをつなぐフレーム（トップチューブ）が斜めに下がっている形を指します。
                                </p>
                            </div>
                            <div className="py-4 pb-0 d-md-none"></div>
                            <div className="py-1 pb-0 d-md-none"></div>
                        </div>
                    </div>

                    <div className="col-6 d-md-none tb-border-start tb-border-end"></div>

                    <div className="col-12 col-md-6 tb-border-start tb-border-top tb-border-end tb-border-end-md-0 tb-border-bottom">
                        <div className="image-wrapper column-height">
                            <Img
                                className="js-reveal-image"
                                fluid={data.file.childImageSharp.fluid}
                            />
                        </div>
                    </div>

                    <div className="col-md-3 d-none d-md-block tb-border-start tb-border-end"></div>
                </div>

                {/* Spacer row */}
                <div className="row d-none d-md-flex">
                    <div className="col-6 col-md-3 tb-border-start">
                        <div className="py-5 d-none d-md-block"></div>
                        <div className="py-2 d-none d-md-block"></div>
                        <div className="py-1 d-none d-md-block"></div>
                    </div>
                    <div className="col-6 col-md-3 d-none d-md-block tb-border-start"></div>
                    <div className="col-6 col-md-3 d-none d-md-block tb-border-start"></div>
                    <div className="col-6 col-md-3 tb-border-start tb-border-end"></div>
                </div>
            </div>
        </div>
    );
};

export default FrameSection;
